import React, { Component } from "react"
import PropTypes from "prop-types"
import Sticky from "react-stickynode"
import SbEditable from "storyblok-react"
import Button from "../button"

class Navigation extends Component {
  state = {
    displayNav: false,
    stickyTopValue: "",
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("window:resize", this.onWindowResize)
      this.onWindowResize()
    }
  }

  toggleNav = () => {
    if (document.documentElement.clientWidth <= 1023) {
      const { displayNav } = this.state

      this.setState({
        displayNav: !displayNav,
      })
    }
  }

  onWindowResize = () => {
    const { stickyTopValue } = this.state
    let newStickyTopValue = 0

    if (typeof window !== "undefined")
      if (window.innerWidth <= 1023) newStickyTopValue = 69

    if (newStickyTopValue !== stickyTopValue)
      this.setState({ stickyTopValue: newStickyTopValue })
  }

  render() {
    const { displayNav } = this.state
    const { stickyTopValue } = this.state
    const { anchorList, blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className={`navigation ${displayNav ? "navigation--open" : ""}`}>
          <Sticky activeClass="navigation--stuck" top={stickyTopValue}>
            <div className="navigation__container container">
              <p
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                role="button"
                className="navigation__title"
                onClick={this.toggleNav}
                onKeyPress={this.toggleNav}
                tabIndex={0}
              >
                {blok.title}
              </p>
              <div className="navigation__list">
                <div className="navigation__items">
                  {anchorList &&
                    anchorList.map(a => (
                      <a
                        key={a.anchor}
                        href={`#${a.anchor}`}
                        onClick={this.toggleNav}
                        className={`navigation__item navigation__item--${a.title
                          .replace(/\s+/g, "-")
                          .toLowerCase()}`}
                      >
                        {a.title}
                      </a>
                    ))}
                </div>
                <div className="navigation__actions">
                  <Button
                    iconName="ChevronDown"
                    className="navigation__toggle"
                    onClick={this.toggleNav}
                  />
                  {blok.primary_button &&
                    blok.primary_button.map(content => (
                      <Button
                        key={content._uid}
                        blok={content}
                        className="btn--cta navigation__cta navigation__cta--sm"
                      />
                    ))}
                </div>
              </div>
            </div>
          </Sticky>
        </div>
      </SbEditable>
    )
  }
}

Navigation.defaultTypes = {
  anchorList: [],
  title: "",
}

Navigation.propTypes = {
  anchorList: PropTypes.arrayOf(
    PropTypes.shape({
      anchor: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  blok: PropTypes.shape({
    title: PropTypes.string,
    primary_button: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default Navigation
